<template>
  <white-bg :style="{'min-height': !initLoading ? 'auto': '650px'}">
    <div class="settings__top specialisation__settings__styles" v-if="!initLoading">
      <h3>Настройки деятельности</h3>
      <div class="settings-input" v-if="specializations && selectedSpecializations" style="margin-bottom: 20px">
        <div class="params">Коворкинги</div>
        <multiselect
          v-model="selectedCoworkings"
          :options="coworkings"
          :multiple="true"
          :close-on-select="false" :clear-on-select="false"
          :preserve-search="true"
          placeholder="Выберите коворкинг"
          label="name"
          track-by="name"
          :showLabels="false"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
              <span v-for="(val, index) in values" :key="val.name">{{ val.name }}<span v-if="values.length-1 !== index">, </span></span>
            </span>
          </template>
          <template slot="noOptions">Список коворкингов пуст</template>
          <template slot="noResult">Ничего не найдено</template>
        </multiselect>
        <error-text :text="errors.coworkings"/>
      </div>
      <div class="settings-input" v-if="specializations && selectedSpecializations">
        <div class="params">Специализация</div>
        <multiselect
          v-model="selectedSpecializations"
          :options="specializations"
          :multiple="true"
          :close-on-select="false" :clear-on-select="false"
          :preserve-search="true"
          placeholder="Выберите специализацию"
          label="name"
          track-by="name"
          :showLabels="false"
        >
          <template slot="selection" slot-scope="{ values, search, isOpen }">
            <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
              <span v-for="(val, index) in values" :key="val.name">{{ val.name }}<span v-if="values.length-1 !== index">, </span></span>
            </span>
          </template>
          <template slot="noOptions">Список специализаций пуст</template>
          <template slot="noResult">Ничего не найдено</template>
        </multiselect>
        <error-text :text="errors.specializations"/>
      </div>
      <button-component :loading="loading" variant="filled" @click="update">Сохранить</button-component>
    </div>
    <prices/>
  </white-bg>
</template>

<script>
import ButtonComponent from "@/components/ui/buttons/button-component";
import Prices from "@/pages/Cabinet/Master/Settings/Prices";
import WhiteBg from '../../../../components/ui/white-bg'
import ErrorText from '../../../../components/ui/text/error-text';
import {mapGetters, mapMutations} from 'vuex'
import Multiselect from 'vue-multiselect';

export default {
  name: "Password",
  components: {Prices, WhiteBg, ErrorText, Multiselect, ButtonComponent},
  data() {
    return {
      loading: false,
      form: {},
      errors: {},
      coworkings: null,
      specializations: null,
      selectedCoworkings: null,
      selectedSpecializations: null,
    }
  },
  watch: {
    selectedCoworkings() {
      this.errors.coworkings = null;
    },
    selectedSpecializations() {
      this.errors.specializations = null;
    },
  },
  mounted() {
    this.loadCoworkings();
    this.loadSpecializations();
    this.loadSelectedCoworkings();
    this.loadSelectedSpecializations();
  },
  computed: {
    ...mapGetters(['getUser', 'getCity', 'getCities']),
    initLoading() {
      return !this.coworkings || !this.specializations || !this.selectedCoworkings || !this.selectedSpecializations;
    }
  },
  methods: {
    ...mapMutations(['setCity', 'setUser']),
    loadCoworkings() {
      return this.$api.coworking.list().then(({data}) => this.coworkings = data);
    },
    loadSpecializations() {
      return this.$api.specialization.all().then(({data}) => this.specializations = data);
    },
    loadSelectedCoworkings() {
      return this.$api.master.coworking.list().then(({data}) => this.selectedCoworkings = data);
    },
    loadSelectedSpecializations() {
      return this.$api.master.specialization.list().then(({data}) => this.selectedSpecializations = data);
    },
    update() {
      this.loading = true;
      return this.$api.master.setting.activity.update({
        coworkings: this.selectedCoworkings.map((val) => val.id),
        specializations: this.selectedSpecializations.map((val) => val.id),
      }).then(({data}) => {
        this.setUser(data);
        this.setCity(data.city_id);
        this.errors = {};
        this.$toast.success('Сохранено!');
        this.$eventHub.$emit('price.reload');
      }).catch(({response}) => this.errors = response.data.errors)
        .finally(() => this.loading = false);
    }
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
h3 {
  padding-bottom: 0;
}

.settings {
  padding: 30px 30px 0 30px;

  &__top {
    padding-bottom: 30px;

    h3 {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #383838;
      padding-bottom: 20px;
    }
  }

  &__bottom {
    padding: 30px -15px 0 0;
    border-top: 1px solid #E5E5E5;
    display: flex;

    &-prices {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .close {
        height: 50px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      h3 {
        padding-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
      }

      button {
        margin-top: 0;
        width: auto;
        font-weight: 600;
        font-size: 16px;
        line-height: 1.4;
        color: #B9765B;
        background-color: transparent;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 0 0;

        &:before {
          content: '';
          width: 20px;
          height: 20px;
          margin-right: 5px;
          background-image: url("../../../../assets/images/icons/edit.svg");
          background-position: center center;
          background-size: contain;
        }
      }
    }
  }

  &__services {
    padding-bottom: 10px;

    h3 {
      padding-top: 15px;
    }

    button {
      visibility: visible;
      height: 20px;
      margin-top: 0;
      width: auto;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      color: #B9765B;
      background-color: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 10px 0 25px 0;

      &:before {
        content: '';
        width: 20px;
        height: 20px;
        margin-right: 5px;
        background-image: url("../../../../assets/images/icons/edit.svg");
        background-position: center center;
        background-size: contain;
      }
    }
  }
}

.select {
  height: 37.5px;
  width: 100%;
  max-width: unset;
  margin-bottom: 20px;
}

button {
  width: 100%;
  height: 50px;
  border: none;
  background: #DBBFA7;
  border-radius: 5px;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #383838;
  margin-top: 15px;
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  .camera {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;

    &:hover .camera-visible {
      visibility: visible;
    }

    .camera-visible {
      visibility: hidden;
      position: absolute;
      background: rgba(56, 56, 56, 0.70);
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      img {
        width: 37.95px;
        height: 30.8px;
        border-radius: unset;
      }
    }
  }

  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
  }
}

h3 {
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
  padding-bottom: 0;
}

.params {
  font-family: "Open Sans", sans-serif;
  padding-left: 10px;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #808080;
}

.settings-input {
  position: relative;
  width: 100%;

  input {
    font-family: "Open Sans", sans-serif;
    width: 100%;
    height: 37.5px;
    background: #FFFFFF;
    border: 1px solid #DBBFA7;
    border-radius: 5px;
    padding-left: 20px;
    color: #383838;
    font-size: 16px;

    &::placeholder {
      font-size: 16px;
      line-height: 24px;
      color: #808080;
    }
  }

  button {
    margin-top: 10px;
    width: 20px;
    height: 20px;
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    background-color: transparent;
    border: none;
    background-image: url('../../../../assets/images/icons/eye-off.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
  }

  button.text {
    background-image: url('../../../../assets/images/icons/eye.svg');
  }
}
</style>

<style lang="scss">
.specialisation__settings__styles {
  .multiselect__option {
    &--highlight {
      background-color: #97c1bf;

      &:after {
        background-color: #97c1bf;
      }
    }

    &--selected.multiselect__option--highlight {
      background-color: #b9765b;

      &:after {
        background-color: #b9765b;
      }
    }
  }

  .multiselect__tag {
    background-color: #97c1bf;

    &-icon:focus, .multiselect__tag-icon:hover {
      background-color: #97c1bf;
    }
  }
}

@media screen and (max-width: 1170px) {
  .whiteBg {
    margin: 0 -15px !important;
  }
}
</style>
